import { ValidationErrors } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { AppRoutingKeys, fileBooleanMappings } from '@shared';
import { firstValueFrom, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ValidationKeys } from '../../models';
import { IntervalService } from '../../services/interval.service';
import { IAsyncValidatorHandler } from '../async-validator-handler.interface';
import { CrossTableParams } from '../models/cross-table-params-type';

export class StartAtZeroCheck implements IAsyncValidatorHandler {
	private next: IAsyncValidatorHandler;

	public constructor(private intervalService: IntervalService) {}

	public setNext(nextHandler: IAsyncValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(crossTableParams: CrossTableParams): Promise<ValidationErrors | null> {
		const startAtZeroValidation: ValidationErrors | null = await firstValueFrom(
			of(
				fileBooleanMappings[crossTableParams.tableMetadata[WorkspaceDatabaseKeys.tables.dataMustStartAtZero]]
			).pipe(
				switchMap((mustStartAtZero: boolean) => {
					if (mustStartAtZero) {
						return this.intervalService
							.isFirstRecord$(
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.tableName),
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.workfileId),
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.projectNumber),
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.entityName),
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.entryId),
								crossTableParams.queryParamsMap.get(AppRoutingKeys.queryParamsMap.childEntryId)
							)
							.pipe(
								map((isFirstRecord: boolean) => {
									const depthFromValue =
										crossTableParams.crossControlKey === WorkspaceDatabaseKeys.columns.depthFrom
											? crossTableParams.crossControlValue
											: crossTableParams.controlValue;

									const appliedValidation: ValidationErrors =
										isFirstRecord && depthFromValue !== 0
											? { [ValidationKeys.validationRules.startAtZeroRule]: true }
											: null;

									if (!crossTableParams.crossControl.errors) {
										crossTableParams.crossControl.setErrors(appliedValidation);
									}

									return appliedValidation;
								})
							);
					}
					return of(null);
				})
			)
		);

		if (startAtZeroValidation) {
			return startAtZeroValidation;
		}

		if (this.next) {
			return await this.next.handle(crossTableParams);
		}

		return null;
	}
}
